import { render, staticRenderFns } from "./Science.vue?vue&type=template&id=0ea06625"
import script from "./Science.vue?vue&type=script&lang=js"
export * from "./Science.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports